<template>
  <div class="home"></div>
</template>

<script>
export default {
  name: 'home',
  components: {},
  created () {
    if (location.search) {
      this.$router.push('/productDirection')
    } else {
      this.$router.push('/download')
    }
  }
}
</script>
<style scoped>
iframe {
  overflow: hidden;
}
</style>
